import { GoPlus } from "react-icons/go"
import { nodept } from "../../constant/import"
import { Button } from "../forms"

const NoEmployee=(props:any)=>(<div className=" border w-[50%] mt-4 py-10 border-gray-300 rounded-[8px] p-4 flex justify-center items-center flex-col">

<img src={nodept}/>

<p className="font-bold text-textbg">No Employee</p>
<p className="font-light text-sm my-2  text-center">No employee has been added</p>

<Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Employee
              </>
            }
            onBtnClick={()=>{ props.add(true)}}
          />

</div>)


export{NoEmployee}